var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles } from "@material-ui/core";
import React from "react";
import { IconWrapper } from ".";
export const SortIcon = React.forwardRef((_a, ref) => {
    var { sort } = _a, otherProps = __rest(_a, ["sort"]);
    const classes = useStyles();
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 16, height: 16 }, otherProps),
        React.createElement("path", { d: "M10 7H6L8 3L10 7Z", className: sort === "ASC" ? classes.primary : classes.tertiary }),
        React.createElement("path", { d: "M10 9H6L8 13L10 9Z", className: sort === "DESC" ? classes.primary : classes.tertiary })));
});
const useStyles = makeStyles((theme) => ({
    primary: {
        fill: theme.palette.icon.primary,
    },
    tertiary: {
        fill: theme.palette.icon.tertiary,
    },
}));
//# sourceMappingURL=Sort.js.map